import { Box, IconButton, TextField, styled } from '@mui/material';
import { FC, useEffect, useState } from 'react';

import { BankData } from '@codefluegel/wowis-rest-typescript-client';
import AddIcon from '@mui/icons-material/Add';
import { observer } from 'mobx-react-lite';
import { useKundenApi } from '../../ApiClient';
import EditPencil from '../../assets/MeineDaten/Edit_Pencil.svg';
import useMedia from '../../hooks/useMedia';
import IBANModal from '../dialog/IBANModal';

const StyledTextField = styled(TextField)({
  '& .MuiInputLabel-root': { fontSize: '0.9rem' },
});

interface Props {
  topUserId: number;
}

const IBANTextFieldListForm: FC<Props> = observer(({ topUserId }) => {
  const [textFields, setTextFields] = useState<BankData[]>([]);
  const [ibanModalOpen, setIbanModalOpen] = useState(false);
  const [ibanToEdit, setIbanToEdit] = useState<BankData | undefined>();
  const kundenApi = useKundenApi();
  const isMobile = useMedia('md');

  useEffect(() => {
    const fetchIBANData = async () => {
      const { data } = await kundenApi.getAllKundenBankKonto(topUserId);
      setTextFields(data);
    };
    fetchIBANData();
  }, [kundenApi, topUserId]);

  const handleIBANUpdate = (iban: BankData) => {
    setTextFields(prevFields =>
      prevFields.some(c => c.bankKontoId === iban.bankKontoId)
        ? prevFields.map(c => (c.bankKontoId === iban.bankKontoId ? iban : c))
        : [...prevFields, iban],
    );
  };

  const openIBANModal = (iban?: BankData) => {
    setIbanToEdit(iban);
    setIbanModalOpen(true);
  };

  return (
    <Box width={1} overflow={isMobile ? 'none' : 'auto'} paddingX={1}>
      {textFields.map(iban => (
        <Box key={iban.bankKontoId} paddingBottom={4} my={1}>
          <Box display="flex" flexDirection="row">
            <StyledTextField
              variant="outlined"
              fullWidth
              value={iban.iban}
              label="IBAN"
              disabled
              sx={{ marginRight: 2 }}
            />
            <IconButton size="small" onClick={() => openIBANModal(iban)}>
              <img src={EditPencil} alt="Bearbeiten" width={24} />
            </IconButton>
          </Box>
        </Box>
      ))}
      <Box justifyContent="center" paddingBottom={2} display="flex">
        <IconButton size="small" onClick={() => openIBANModal()}>
          <AddIcon />
        </IconButton>
      </Box>
      <IBANModal
        ibanToEdit={ibanToEdit}
        topUserId={topUserId}
        open={ibanModalOpen}
        onClose={() => setIbanModalOpen(false)}
        updateTextField={handleIBANUpdate}
      />
    </Box>
  );
});

export default IBANTextFieldListForm;
